import {Link, Tooltip, Typography, Stack, IconButton} from "@mui/material";
import Grid from '@mui/material/Grid';
import React from "react";
import CapLevelChip from "../common/CapLevelChip";
import ContentTypeIcon from "./ContentTypeIcon";
import AspectRatioIcon from '@mui/icons-material/AspectRatio';

const SUPPORTED_FILE_EXTENSION = '.pdf';

const contentInfoStyle = (onExpandContent) => ({
    display: "flex",
    gap:"0.5em", 
    alignItems: "center", 
    overflow: 'hidden',
    textOverflow: 'ellipsis', 
    whiteSpace: 'nowrap',
    ...(!onExpandContent
        ? {maxWidth: {xs: "15rem", sm: "20rem", md: "100%"}, marginTop: "1.6rem"}
        : {maxWidth: {xs: "20rem", xl: "24rem"}})
});

export default function SessionContentDetails({ contentInfos, onPdfClick, onExpandContent }) {

    return (
        <Stack sx={{display: 'flex'}}> {
            contentInfos.map(content => {
                const isPdfContent = content.externalUrl?.includes(SUPPORTED_FILE_EXTENSION);
                const showExpandButton = isPdfContent && onExpandContent;

                return (
                    <Grid key={content.id} sx={contentInfoStyle(!!onExpandContent)}>
                        <CapLevelChip capLevel={content.level} />
                        <ContentTypeIcon contentType={content.contentType} />
                        <Typography variant="body2" sx={{textOverflow: 'ellipsis', overflow: 'hidden', marginLeft: '1rem'}}>
                            <Tooltip title={content.name} variant="body2">
                                <Link
                                    href={content.externalUrl}
                                    rel="noopener noreferrer"
                                    onClick={(e) => {
                                        if (isPdfContent && onPdfClick) {
                                            e.preventDefault();
                                            onPdfClick(content.externalUrl, content.name);
                                        }
                                    }}
                                    target={isPdfContent && onPdfClick ? undefined : "_blank"}>
                                    {content.name}
                                </Link>
                            </Tooltip>
                        </Typography>
                        {showExpandButton && (
                            <IconButton
                                size="small"
                                onClick={() => onExpandContent(content.externalUrl, content.name)}
                                title="Pop-out window"
                                sx={{marginBottom: '0.125rem'}}>
                                <AspectRatioIcon fontSize="small"/>
                            </IconButton>
                        )}
                    </Grid>
                );
            })
        }
        </Stack>
    );
}